import React, { FC } from "react";
import { Box, Tooltip as MuiTooltip, TooltipProps } from "@mui/material";

const Tooltip: FC<TooltipProps> = ({ children, ...props }: TooltipProps) => (
  <MuiTooltip enterDelay={300} leaveDelay={200} {...props}>
    <Box component="span" color={props.color}>
      {children}
    </Box>
  </MuiTooltip>
);

export default Tooltip;
